import React from 'react';
import styled from 'styled-components';
import { Home, TreePine } from 'lucide-react';

const VenueTypeContainer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: ${props => props.size === 'small' ? '0.8rem' : '0.85rem'};
  font-weight: 500;
  padding: ${props => props.size === 'small' ? '0.3rem 0.6rem' : '0.4rem 0.8rem'};
  border-radius: ${props => props.size === 'small' ? '12px' : '16px'};
  flex-shrink: 0;
  background-color: ${props => props.venue_type === 'Indoor' ? '#EEF2FF' : '#ECFDF5'};
  color: ${props => props.venue_type === 'Indoor' ? '#4F46E5' : '#059669'};
  border: 1px solid ${props => props.venue_type === 'Indoor' ? '#C7D2FE' : '#BBF7D0'};
  cursor: ${props => props.onClick ? 'pointer' : 'default'};
  transition: ${props => props.onClick ? 'transform 0.2s ease' : 'none'};
  will-change: transform;
  
  &:hover {
    opacity: ${props => props.onClick ? '0.8' : '1'};
  }
  
  svg {
    margin-right: 0.25rem;
    color: ${props => props.venue_type === 'Indoor' ? '#4F46E5' : '#059669'};
  }
`;

const VenueTypeIndicator = ({ venueType, size = 'medium', className, style, onClick }) => {
  if (!venueType) return null;
  
  const iconSize = size === 'small' ? 14 : 16;
  
  return (
    venueType && (
    <VenueTypeContainer 
      venue_type={venueType} 
      size={size}
      className={className}
      style={style}
      onClick={onClick}
    >
      {venueType === 'Indoor' ? (
        <Home size={iconSize} />
      ) : (
        <TreePine size={iconSize} />
      )}
      {venueType}
    </VenueTypeContainer>
    )
  );
};

export default VenueTypeIndicator;